import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchHeaderProducts, getItemList } from "../services/api_service";
import { Item } from "../models/item_model";
import { MasterProduct } from "../models/master_product";
import { HomePage } from "./components/home_page";
import WappIcon from "../assets/svg/whatsapp.svg";
import { useMediaQuery } from "react-responsive";

export default function Home() {
  const [bootLoader, setBootLoader] = useState(true);
  const [celebItems, setCelebItems] = useState<Item[]>([]);
  const [topRated, setTopRated] = useState<Item[]>([]);
  const [products, setProducts] = useState<MasterProduct[]>([]);
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ maxWidth: 768 });

useEffect(() => {
  const cached = localStorage.getItem("homeData");

  if (cached) {
    try {
      const data = JSON.parse(cached);
      if (data.products?.length && data.celebItems?.length && data.topRated?.length) {
        setProducts(data.products);
        setCelebItems(data.celebItems);
        setTopRated(data.topRated);
        setBootLoader(false);
        return;
      }
    } catch (err) {    }
  }

  const fetchAndCache = async () => {
    try {
      const fetchedProducts = await fetchHeaderProducts();
      const celebItemsResp = await getItemList({ isCelebrityChoice: true, pageSize: 10 });
      const topRatedResp = await getItemList({ isCelebrityChoice: false, pageSize: 10 });

      const celebItemsData = celebItemsResp?.records || [];
      const topRatedData = topRatedResp?.records || [];

      setProducts(fetchedProducts);
      setCelebItems(celebItemsData);
      setTopRated(topRatedData);

      localStorage.setItem("homeData", JSON.stringify({
        products: fetchedProducts,
        celebItems: celebItemsData,
        topRated: topRatedData
      }));
    } catch (error) {
      console.error(error);
    } finally {
      setBootLoader(false);
    }
  };

  fetchAndCache();
}, []);

  if (bootLoader) {
    return (
      <div style={styles.loadingContainer}>
        <img
          src={require("../assets/images/full_logo.png")}
          style={styles.loaderLogo}
          alt="Loading..."
        />
      </div>
    );
  }

return (
  <div style={styles.container}>
    <HomePage
      products={products}
      celebItems={celebItems}
      topRated={topRated}
      onShowMore={(isCelebrity) => {
        navigate("/result", { state: { isCelebrityChoice: isCelebrity } });
      }}
    />

    {/* Floating WhatsApp Icon */}
    <img
      src={WappIcon}
      alt="WhatsApp"
      onClick={() => window.open("https://wa.me/9246595003", "_blank")} // change to your number
      style={{
        position: "fixed",
        bottom: 24,
        right: 24,
        width: isMobile ? "7vh" : "10vh",
        height: isMobile ? "7vh" : "10vh",
        cursor: "pointer",
        zIndex: 1000,
        transition: "transform 0.2s ease-in-out",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
      onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
    />
  </div>
);

}

// Converted styles to React Web CSS-in-JS
const styles: { [key: string]: React.CSSProperties } = {
  container: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    width: "100%",
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
  },
  loaderLogo: {
    height: 80,
    width: 250,
    objectFit: "contain",
  },
  breadcrumbContainer: {
    backgroundColor: "#693B2F",
    padding: 15,
  },
  breadcrumbText: {
    color: "#fff",
    fontSize: 16,
  },
  filterRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: 8,
    alignItems: "center",
    padding: 10,
  },
  filterBtn: {
    border: "1px solid grey",
    borderRadius: 20,
    padding: 10,
    marginRight: 8,
  },
  filterChip: {
    border: "1px solid grey",
    borderRadius: 20,
    padding: "8px 14px",
    marginRight: 8,
    marginTop: 5,
  },
  filterChipText: {
    fontSize: 14,
    color: "#333",
  },
  resultsContainer: {
    backgroundColor: "#F8F1F1",
    borderRadius: 10,
    padding: 15,
    margin: 12,
  },
  resultsText: {
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 12,
  },
  grid: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
  },
  gridItem: {
    width: "23%",
    marginBottom: 15,
  },
  productImg: {
    width: "100%",
    height: 100,
    borderRadius: 8,
    marginBottom: 6,
    backgroundColor: "#ddd",
    objectFit: "cover",
  },
  productName: {
    fontSize: 13,
    fontWeight: 500,
    color: "#333",
  },
};
